export const LogsColumns = [
    {
        name: "Severidade",
        id: "severity"
    },
    {
        name: "Data",
        id: "date"
    },
    {
        name: "Usuário",
        id: "name"
    },
    {
        name: "Email",
        id: "email"
    },
    {
        name: "Ação",
        id: "action"
    },
    {
        name: "Menu",
        id: "menu"
    },
    {
        name: "Descrição",
        id: "resume"
    }
];